import {LOCAL_STORAGE_ITEMS} from "../constants";

export default class LocalStorage {
  static setObjectItem(itemName, obj) {
    localStorage.setItem(itemName, JSON.stringify(obj))
  }

  static getObjectItem(itemName) {
    const content = localStorage.getItem(itemName)
    if (content) {
      return JSON.parse(content)
    }
    return undefined;

  }

  static getToken() {
    return localStorage.getItem(LOCAL_STORAGE_ITEMS.token)
  }

  static setToken(token) {
    return localStorage.setItem(LOCAL_STORAGE_ITEMS.token, token)
  }

  static getItem(itemName) {
    return localStorage.getItem(itemName)
  }

  static setItem(itemName, value) {
    localStorage.setItem(itemName, value)
  }

  static removeItem(itemName) {
    localStorage.removeItem(itemName)
  }
}
